<!-- <svg-icon src="{{iconTypeMap[iconButtonType].src}}" [svgClass]="iconTypeMap[iconButtonType].svgClass"></svg-icon> -->

<svg-icon [src]="iconTypeMap[iconButtonType].src" [svgClass]="iconTypeMap[iconButtonType].svgClass"></svg-icon>

